/** An invalidated or superseded read may finish, but must not repopulate a catalog. */
export function createReferenceOptionsCache(load, { ttlMs = 300_000, now = Date.now } = {}) {
  const values = new Map();
  const pending = new Map();
  let generation = 0;

  const invalidate = () => {
    generation += 1;
    values.clear();
    pending.clear();
  };

  const fetch = ({ force = false, includeInactive = false } = {}) => {
    const key = Boolean(includeInactive);
    if (!force && pending.has(key)) return pending.get(key);
    const cached = values.get(key);
    if (!force && cached && now() - cached.loadedAt < ttlMs) return Promise.resolve(cached.data);

    const startedGeneration = generation;
    const promise = Promise.resolve().then(() => load(key)).then((data) => {
      if (generation === startedGeneration && pending.get(key) === promise) {
        values.set(key, { data, loadedAt: now() });
      }
      return data;
    }).finally(() => {
      if (pending.get(key) === promise) pending.delete(key);
    });
    pending.set(key, promise);
    return promise;
  };

  return { fetch, invalidate };
}
